import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles('default-landing-form', ({ breakpoints: { up }, palette: { grey, common } }) => ({
  container: {
    padding: '1.25rem',
    background: grey[200],
    color: grey[800],

    [up('md')]: {
      width: '29.375rem',
    },

    '& input': {
      background: common.white,
      borderRadius: '0.25rem',
      borderTop: `1px solid ${grey[200]}`,
    },

    '& .MuiInputBase-adornedEnd': {
      background: common.white,
    },
  },
  mainTitle: {
    margin: '0 0 1.5rem',
    color: grey[800],
    fontSize: '1.5rem',
    lineHeight: 1.2,
  },
  subtitle: {
    margin: '0 0 0.813rem',
  },
  formSection: {
    marginBottom: '1.5rem',
  },
  checkboxSection: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    padding: '0 0.25rem',
    '& .MuiFormControlLabel-root': {
      width: '50%',
      padding: '0.375rem 0',
      '@media(max-width: 390px)': {
        width: '60%',
      },
    },
  },
  label: {
    margin: '0 0 0.5rem',
    '& .MuiButtonBase-root': {
      backgroundColor: common.white,
    },
  },
  rulesText: {
    textAlign: 'center',
    margin: '2rem 0 1.5rem',
    '& a': {
      color: '#00305e',
    },
    [up('md')]: {
      textAlign: 'left',
    },
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'center',

    [up('md')]: {
      display: 'block',
    },
  },
}));

export default useStyles;
